var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { getStripComponentFromStripData } from "../../services/pursuit/stripsService";
export default function StripMultipleColumnsContainer(props) {
    var fields = props.fields, children = props.children;
    var columnsPerRow = +fields.columns || 2;
    var numberOfRows = children ? Math.ceil(children.length / columnsPerRow) : 0;
    var firstColumnWidth = fields.firstColumnWidth || 6;
    var firstColumnOffset = fields.firstColumnOffset || 0;
    var secondColumnWidth = fields.seccondColumnWidth || 6;
    var secondColumnOffset = fields.seccondColumnOffset || 0;
    var thirdColumnWidth = fields.thirdColumnWidth || 6;
    var thirdColumnOffset = fields.thirdColumnOffset || 0;
    var rows = Array.from({ length: numberOfRows }, function (_, i) {
        var startIndex = i * columnsPerRow;
        var endIndex = startIndex + columnsPerRow;
        return children.slice(startIndex, endIndex);
    });
    var renderContent = function (child) {
        var TitleTag = (child.fields.titleTag || "p");
        var PreTitleTag = (child.fields.preTitleTag || "p");
        var columnClassName = "column-content ".concat(child.fields.backgroundColor || "", " \n        ").concat(child.fields.topPadding ? "top-padding-".concat(child.fields.topPadding) : "", " \n        ").concat(child.fields.bottomPadding ? "bottom-padding-".concat(child.fields.bottomPadding) : "", " \n        ").concat(child.fields.topMargin ? "top-margin-".concat(child.fields.topMargin) : "", " \n        ").concat(child.fields.bottomMargin ? "bottom-margin-".concat(child.fields.bottomMargin) : "").trim();
        var id = child.fields.jumplinkLabel
            ? child.fields.jumplinkLabel.replace(/ /g, '')
            : undefined;
        if (child.fields.bottomContent) {
            return (React.createElement("div", { className: columnClassName, id: id },
                React.createElement("div", { className: "d-flex flex-column justify-content-between h-100" },
                    child.fields.content && (React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: child.fields.content } })),
                    React.createElement("div", { className: "bottom-content", dangerouslySetInnerHTML: { __html: child.fields.bottomContent } }))));
        }
        if (child.fields.displayTitle || child.fields.content) {
            return (React.createElement("div", { className: columnClassName, id: id },
                child.fields.preTitle && (React.createElement(PreTitleTag, { className: "pre-title ".concat(child.fields.preTitleStyle || ""), itemProp: "title", dangerouslySetInnerHTML: { __html: child.fields.preTitle } })),
                child.fields.displayTitle && (React.createElement(TitleTag, { className: "content-title ".concat(child.fields.titleStyle || ""), itemProp: "title", dangerouslySetInnerHTML: { __html: child.fields.displayTitle } })),
                child.fields.content && (React.createElement("div", { className: "column", dangerouslySetInnerHTML: { __html: child.fields.content } }))));
        }
        return null;
    };
    return (React.createElement("div", __assign({ className: "strip spa-multiple-columns-container "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + ((fields.borderBottom) ? " border-bottom" : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            fields.displayTitle && (React.createElement("div", { className: "row pc-content-row justify-content-center" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "display-title-container " + (fields.titleAlignment) ? fields.titleAlignment : "text-center" },
                        React.createElement("h1", { className: "".concat(fields.titleStyle ? "".concat(fields.titleStyle, " display-title") : "display-title"), itemProp: "title", dangerouslySetInnerHTML: {
                                __html: fields.displayTitle,
                            } }))))),
            rows.map(function (rowChildren, rowIndex) { return (React.createElement("div", { className: "row pc-content-row", key: rowIndex }, rowChildren.map(function (child, colIndex) {
                var colClassName = "pc-content-column col-12 ";
                var bgColorClass = "";
                if (child.fields.backgroundColor && child.fields.backgroundColor !== "bg-transparent" && child.fields.backgroundColor !== "inherit") {
                    bgColorClass += " ".concat(child.fields.backgroundColor, " with-extra-padding");
                }
                if (columnsPerRow === 2 || columnsPerRow == 3) {
                    if (colIndex === 0) {
                        colClassName += " offset-md-".concat(firstColumnOffset, " col-md-").concat(firstColumnWidth);
                    }
                    else if (colIndex === 1) {
                        colClassName += " offset-md-".concat(secondColumnOffset, " col-md-").concat(secondColumnWidth);
                    }
                    else if (colIndex === 2) {
                        colClassName += " offset-md-".concat(thirdColumnOffset, " col-md-").concat(thirdColumnWidth);
                    }
                }
                else {
                    var colWidth = Math.floor(12 / columnsPerRow);
                    colClassName += " col-md-".concat(colWidth);
                }
                if (child.fields.alignBottom) {
                    colClassName += " align-bottom d-inline";
                }
                return (React.createElement("div", { className: colClassName, key: colIndex }, child.children && (React.createElement("div", { className: "column-strips-folder " + bgColorClass +
                        (child.children.some(function (f) { return f.fields.alignBottom; }) ? " d-inline" : "") }, child.stripClassName === "spa.pccontentstripsfolder" &&
                    child.children.map(function (folderChildren, folderChildrenIndex) {
                        if (folderChildren.stripClassName === "sky23.pccontent") {
                            return (React.createElement("div", { className: "folder-strip" +
                                    (folderChildren.fields.alignBottom ? " align-bottom d-inline" : ""), key: folderChildrenIndex }, renderContent(folderChildren)));
                        }
                        else {
                            return (React.createElement("div", { className: "folder-strip", key: folderChildrenIndex }, getStripComponentFromStripData(folderChildren)));
                        }
                    })))));
            }))); }))));
}
